import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  FaSearch, 
  FaBookOpen, 
  FaChevronLeft, 
  FaChevronRight, 
  FaBook, 
  FaTimes, 
  FaPaperPlane, 
  FaUser, 
  FaEnvelope, 
  FaEdit, 
  FaPlus 
} from 'react-icons/fa';
import { useLanguage } from '../../contexts/LanguageContext';
import { apiGet, apiPost } from "../../services/api";

// Переводы
const translations = {
    kz: {
      pageTitle: 'Жаңа түсімдер',
      pageSubtitle: 'Біздің кітапханадан қызықтыратын кітаптарды табыңыз',
      searchPlaceholder: 'Кітап атауын немесе авторды енгізіңіз...',
      searchButton: 'Іздеу',
      booksFound: 'табылды',
      bookWord: 'кітап',
      booksWord: 'кітап',
      manyBooksWord: 'кітап',
      noBooksFound: 'Кітаптар табылмады',
      loading: 'Кітаптар жүктелуде...',
      noAvailableBooks: 'Қолжетімді кітаптар жоқ',
      booksComingSoon: 'Кітаптар жақын арада пайда болады',
      changeSearchQuery: 'Іздеу сұрауын өзгертіп көріңіз',
      moreDetails: 'Толығырақ',
      orderTitle: 'Қорларды қайта қалыптастыруға тапсырыс',
      orderSubtitle: 'Қажетті кітаптарға тапсырыс беру',
      orderButton: 'Тапсырыс беру',
      addNewBook: 'Жаңа кітапқа тапсырыс',
      author: 'Автор',
      book: 'Кітап атауы',
      note: 'Қосымша ескертпе',
      fullName: 'Толық аты-жөні',
      email: 'Электрондық пошта',
      send: 'Жіберу',
      cancel: 'Бас тарту',
      success: 'Тапсырыс сәтті жіберілді!',
      orderLoading: 'Жіберілуде...',
      required: 'Міндетті өріс',
      invalidEmail: 'Email форматы дұрыс емес',
      authorPlaceholder: 'Автор атын енгізіңіз',
      bookPlaceholder: 'Кітап атауын енгізіңіз',
      namePlaceholder: 'Толық атыңызды енгізіңіз',
      emailPlaceholder: 'Email мекенжайыңызды енгізіңіз',
      notePlaceholder: 'Қосымша ақпарат (міндетті емес)',
      successMessage: 'Біз сіздің тапсырысыңызды жақын арада қарастырамыз'
    },
    ru: {
      pageTitle: 'Новые поступления',
      pageSubtitle: 'Найдите интересующие вас книги в нашей библиотеке',
      searchPlaceholder: 'Введите название книги или автора...',
      searchButton: 'Поиск',
      booksFound: 'Найдено',
      bookWord: 'книга',
      booksWord: 'книги',
      manyBooksWord: 'книг',
      noBooksFound: 'Книги не найдены',
      loading: 'Загрузка книг...',
      noAvailableBooks: 'Нет доступных книг',
      booksComingSoon: 'Книги скоро появятся',
      changeSearchQuery: 'Попробуйте изменить поисковый запрос',
      moreDetails: 'Подробнее',
      orderTitle: 'Заказ на докомплектование фонда',
      orderSubtitle: 'Заказ необходимых книг для библиотеки',
      orderButton: 'Сделать заказ',
      addNewBook: 'Заказать новую книгу',
      author: 'Автор',
      book: 'Название книги',
      note: 'Дополнительное примечание',
      fullName: 'Полное имя',
      email: 'Электронная почта',
      send: 'Отправить',
      cancel: 'Отмена',
      success: 'Заказ успешно отправлен!',
      orderLoading: 'Отправка...',
      required: 'Поле обязательно',
      invalidEmail: 'Неверный формат email',
      authorPlaceholder: 'Введите имя автора',
      bookPlaceholder: 'Введите название книги',
      namePlaceholder: 'Введите ваше полное имя',
      emailPlaceholder: 'Введите ваш email',
      notePlaceholder: 'Дополнительная информация (необязательно)',
      successMessage: 'Мы рассмотрим ваш заказ в ближайшее время'
    },
    en: {
      pageTitle: 'New arrivals',
      pageSubtitle: 'Find books of interest in our library',
      searchPlaceholder: 'Enter book title or author...',
      searchButton: 'Search',
      booksFound: 'Found',
      bookWord: 'book',
      booksWord: 'books',
      manyBooksWord: 'books',
      noBooksFound: 'No books found',
      loading: 'Loading books...',
      noAvailableBooks: 'No available books',
      booksComingSoon: 'Books coming soon',
      changeSearchQuery: 'Try changing your search query',
      moreDetails: 'More details',
      orderTitle: 'Order to Resupply Fund',
      orderSubtitle: 'Order necessary books for the library',
      orderButton: 'Place Order',
      addNewBook: 'Order new book',
      author: 'Author',
      book: 'Book Title',
      note: 'Additional Note',
      fullName: 'Full Name',
      email: 'Email Address',
      send: 'Send',
      cancel: 'Cancel',
      success: 'Order sent successfully!',
      orderLoading: 'Sending...',
      required: 'Required field',
      invalidEmail: 'Invalid email format',
      authorPlaceholder: 'Enter author name',
      bookPlaceholder: 'Enter book title',
      namePlaceholder: 'Enter your full name',
      emailPlaceholder: 'Enter your email',
      notePlaceholder: 'Additional information (optional)',
      successMessage: 'We will review your order shortly'
  }
};

const BooksSearchPage = () => {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalBooks, setTotalBooks] = useState(0);
  const booksPerPage = 12;
  
  // Состояние для модального окна заказа
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
  const [orderFormData, setOrderFormData] = useState({
    Author: '',
    Book: '',
    Note: '',
    FullName: '',
    Email: ''
  });
  const [orderLoading, setOrderLoading] = useState(false);
  const [orderSuccess, setOrderSuccess] = useState(false);
  const [orderErrors, setOrderErrors] = useState({});
  
  const navigate = useNavigate();
  const { currentLanguage } = useLanguage();
  const t = translations[currentLanguage] || translations.kz;

  // Загрузка книг
  const loadBooks = async (page = 1, query = '') => {
    setLoading(true);
    try {
      const response = await apiGet(`${process.env.REACT_APP_API_URL}/api/books`, {
        params: {
          page: page,
          limit: booksPerPage,
          search: query
        }
      });
      
      if (response.data) {
        setBooks(response.data.books || []);
        setTotalBooks(response.data.total || 0);
        setTotalPages(Math.ceil((response.data.total || 0) / booksPerPage));
      }
    } catch (error) {
      console.error('Error loading books:', error);
      setBooks([]);
    } finally {
      setLoading(false);
    }
  };

  // Загрузка при монтировании компонента
  useEffect(() => {
    loadBooks(currentPage, searchQuery);
  }, [currentPage]);

  // Обработка поиска
  const handleSearch = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    loadBooks(1, searchQuery);
  };

  // Обработка изменения страницы
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // Переход к детальной странице книги
  const handleBookClick = (bookId) => {
    navigate(`/book/${bookId}`);
  };

  // Генерация номеров страниц для пагинации
  const generatePageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;
    
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      const start = Math.max(1, currentPage - 2);
      const end = Math.min(totalPages, start + maxVisiblePages - 1);
      
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
    }
    
    return pages;
  };

  // Функции для заказа книг
  const validateOrderForm = () => {
    const newErrors = {};
    
    if (!orderFormData.Author.trim()) newErrors.Author = t.required;
    if (!orderFormData.Book.trim()) newErrors.Book = t.required;
    if (!orderFormData.FullName.trim()) newErrors.FullName = t.required;
    if (!orderFormData.Email.trim()) newErrors.Email = t.required;
    else if (!orderFormData.Email.includes('@')) newErrors.Email = t.invalidEmail;

    setOrderErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleOrderSubmit = async () => {
    if (!validateOrderForm()) return;

    setOrderLoading(true);
    try {
      const response = await apiPost(`${process.env.REACT_APP_API_URL}/api/order`, orderFormData);

      if (response.status === 201) {
        setOrderSuccess(true);
        setOrderFormData({
          Author: '',
          Book: '',
          Note: '',
          FullName: '',
          Email: ''
        });
        setTimeout(() => {
          setOrderSuccess(false);
          setIsOrderModalOpen(false);
        }, 2000);
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Произошла ошибка при отправке заказа');
    } finally {
      setOrderLoading(false);
    }
  };

  const handleOrderInputChange = (field, value) => {
    setOrderFormData(prev => ({ ...prev, [field]: value }));
    if (orderErrors[field]) {
      setOrderErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  // Функция для получения правильной формы слова "книга"
  const getBooksWord = (count) => {
    if (count === 1) return t.bookWord;
    if (count < 5) return t.booksWord;
    return t.manyBooksWord;
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Заголовок и поиск */}
        <div className="text-center mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            {t.pageTitle}
          </h1>
          <p className="text-lg text-gray-600 mb-8">
            {t.pageSubtitle}
          </p>
          
          {/* Форма поиска */}
          <div className="max-w-2xl mx-auto mb-6">
            <div className="relative">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder={t.searchPlaceholder}
                className="w-full px-4 py-3 pl-12 pr-16 text-lg border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)] focus:border-[var(--primary-color)]"
                onKeyPress={(e) => e.key === 'Enter' && handleSearch(e)}
              />
              <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg" />
              <button
                onClick={handleSearch}
                disabled={loading}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 px-4 py-2 bg-[var(--primary-color)] text-white rounded-md hover:bg-[var(--primary-light)] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[var(--primary-color)] disabled:opacity-50 transition-all duration-200"
              >
                {loading ? '...' : t.searchButton}
              </button>
            </div>
          </div>

          {/* Компонент заказа книг */}
          <div className="max-w-2xl mx-auto mb-8">
            <div className="bg-gradient-to-r from-[var(--primary-color)] to-[var(--primary-light)] rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                <div className="flex items-center space-x-3 text-center sm:text-left">
                  <div className="p-3 bg-white bg-opacity-20 rounded-lg">
                    <FaBook className="text-2xl text-white" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-white">{t.orderTitle}</h3>
                    <p className="text-white text-opacity-80 text-sm">{t.orderSubtitle}</p>
                  </div>
                </div>
                
                <button
                  onClick={() => setIsOrderModalOpen(true)}
                  className="bg-white text-[var(--primary-color)] font-semibold py-3 px-6 rounded-lg hover:bg-gray-50 transition-all duration-200 flex items-center space-x-2 whitespace-nowrap shadow-md"
                >
                  <FaPlus />
                  <span>{t.addNewBook}</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Результаты поиска */}
        <div className="mb-6">
          <p className="text-gray-600">
            {totalBooks > 0 ? (
              <>{t.booksFound} {totalBooks} {getBooksWord(totalBooks)}</>
            ) : (
              searchQuery ? t.noBooksFound : t.loading
            )}
          </p>
        </div>

        {/* Сетка книг - ОБНОВЛЕННАЯ С КЛАССИЧЕСКИМ ФОРМАТОМ */}
        {loading ? (
          <div className="flex justify-center items-center py-20">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[var(--primary-color)]"></div>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-6 mb-8">
              {books.map((book) => (
                <div
                  key={book.id}
                  onClick={() => handleBookClick(book.id)}
                  className="bg-white rounded-lg shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer group overflow-hidden flex flex-col"
                >
                  {/* Изображение книги в классическом книжном формате */}
                  <div className="relative overflow-hidden bg-gray-100 flex-shrink-0">
                    <div className="aspect-[2/3]">
                      <img
                        src={`${process.env.REACT_APP_API_URL}${book.img_url}`}
                        alt={book.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                        onError={(e) => {
                          e.target.src = 'https://via.placeholder.com/200x300/e5e7eb/9ca3af?text=Нет+изображения';
                        }}
                      />
                    </div>
                    
                    {/* Оверлей при наведении */}
                    <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-all duration-300 flex items-center justify-center">
                      <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-white text-center px-2">
                        <FaBookOpen className="text-2xl mb-2 mx-auto" />
                        <span className="text-xs font-medium">{t.moreDetails}</span>
                      </div>
                    </div>
                  </div>
                  
                  {/* Информация о книге - компактная */}
                  <div className="p-3 flex-grow flex flex-col">
                    <h3 className="font-semibold text-gray-900 text-sm mb-1 line-clamp-2 group-hover:text-[var(--primary-color)] transition-colors duration-200 flex-grow">
                      {book.title}
                    </h3>
                    <p className="text-gray-600 text-xs mb-2 line-clamp-1">
                      {book.author}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Пагинация */}
            {totalPages > 1 && (
              <div className="flex justify-center items-center space-x-2">
                {/* Предыдущая страница */}
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="p-2 rounded-md border border-gray-300 text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
                >
                  <FaChevronLeft />
                </button>

                {/* Номера страниц */}
                {generatePageNumbers().map((page) => (
                  <button
                    key={page}
                    onClick={() => handlePageChange(page)}
                    className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
                      currentPage === page
                        ? 'bg-[var(--primary-color)] text-white shadow-md'
                        : 'border border-gray-300 text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    {page}
                  </button>
                ))}

                {/* Следующая страница */}
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="p-2 rounded-md border border-gray-300 text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
                >
                  <FaChevronRight />
                </button>
              </div>
            )}

            {/* Пустое состояние */}
            {!loading && books.length === 0 && (
              <div className="text-center py-20">
                <FaBookOpen className="text-6xl text-gray-300 mb-4 mx-auto" />
                <h3 className="text-xl font-medium text-gray-500 mb-2">
                  {searchQuery ? t.noBooksFound : t.noAvailableBooks}
                </h3>
                <p className="text-gray-400">
                  {searchQuery ? t.changeSearchQuery : t.booksComingSoon}
                </p>
              </div>
            )}
          </>
        )}
      </div>

      {/* Модальное окно заказа */}
      {isOrderModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* Блюр фон */}
          <div 
            className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
            onClick={() => setIsOrderModalOpen(false)}
          />
          
          {/* Модальное содержимое */}
          <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md max-h-[90vh] overflow-y-auto">
            {/* Заголовок */}
            <div className="bg-gradient-to-r from-[var(--primary-color)] to-[var(--primary-light)] p-6 rounded-t-2xl">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="p-2 bg-white bg-opacity-20 rounded-lg">
                    <FaBook className="text-xl text-white" />
                  </div>
                  <div>
                    <h2 className="text-xl font-bold text-white">{t.orderTitle}</h2>
                    <p className="text-white text-opacity-80 text-sm">{t.orderSubtitle}</p>
                  </div>
                </div>
                <button
                  onClick={() => setIsOrderModalOpen(false)}
                  className="p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-all"
                >
                  <FaTimes className="text-white text-lg" />
                </button>
              </div>
            </div>

            {/* Форма */}
            <div className="p-6">
              {orderSuccess ? (
                <div className="text-center py-8">
                  <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
                    <FaPaperPlane className="text-2xl text-green-600" />
                  </div>
                  <h3 className="text-lg font-semibold text-green-600 mb-2">{t.success}</h3>
                  <p className="text-gray-600">{t.successMessage}</p>
                </div>
              ) : (
                <div className="space-y-4">
                  {/* Автор */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      <FaUser className="inline mr-2" />
                      {t.author} *
                    </label>
                    <input
                      type="text"
                      value={orderFormData.Author}
                      onChange={(e) => handleOrderInputChange('Author', e.target.value)}
                      className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)] transition-all ${
                        orderErrors.Author ? 'border-red-500' : 'border-gray-300'
                      }`}
                      placeholder={t.authorPlaceholder}
                    />
                    {orderErrors.Author && <p className="text-red-500 text-xs mt-1">{orderErrors.Author}</p>}
                  </div>

                  {/* Название книги */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      <FaBook className="inline mr-2" />
                      {t.book} *
                    </label>
                    <input
                      type="text"
                      value={orderFormData.Book}
                      onChange={(e) => handleOrderInputChange('Book', e.target.value)}
                      className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)] transition-all ${
                        orderErrors.Book ? 'border-red-500' : 'border-gray-300'
                      }`}
                      placeholder={t.bookPlaceholder}
                    />
                    {orderErrors.Book && <p className="text-red-500 text-xs mt-1">{orderErrors.Book}</p>}
                  </div>

                  {/* Полное имя */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      <FaUser className="inline mr-2" />
                      {t.fullName} *
                    </label>
                    <input
                      type="text"
                      value={orderFormData.FullName}
                      onChange={(e) => handleOrderInputChange('FullName', e.target.value)}
                      className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)] transition-all ${
                        orderErrors.FullName ? 'border-red-500' : 'border-gray-300'
                      }`}
                      placeholder={t.namePlaceholder}
                    />
                    {orderErrors.FullName && <p className="text-red-500 text-xs mt-1">{orderErrors.FullName}</p>}
                  </div>

                  {/* Email */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      <FaEnvelope className="inline mr-2" />
                      {t.email} *
                    </label>
                    <input
                      type="email"
                      value={orderFormData.Email}
                      onChange={(e) => handleOrderInputChange('Email', e.target.value)}
                      className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)] transition-all ${
                        orderErrors.Email ? 'border-red-500' : 'border-gray-300'
                      }`}
                      placeholder={t.emailPlaceholder}
                    />
                    {orderErrors.Email && <p className="text-red-500 text-xs mt-1">{orderErrors.Email}</p>}
                  </div>

                  {/* Примечание */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      <FaEdit className="inline mr-2" />
                      {t.note}
                    </label>
                    <textarea
                      value={orderFormData.Note}
                      onChange={(e) => handleOrderInputChange('Note', e.target.value)}
                      rows={3}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)] transition-all resize-none"
                      placeholder={t.notePlaceholder}
                    />
                  </div>

                  {/* Кнопки */}
                  <div className="flex space-x-3 pt-4">
                    <button
                      type="button"
                      onClick={() => setIsOrderModalOpen(false)}
                      className="flex-1 py-3 px-4 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-all font-medium"
                    >
                      {t.cancel}
                    </button>
                    <button
                      type="button"
                      onClick={handleOrderSubmit}
                      disabled={orderLoading}
                      className="flex-1 py-3 px-4 bg-gradient-to-r from-[var(--primary-color)] to-[var(--primary-light)] text-white rounded-lg hover:from-[var(--primary-light)] hover:to-[var(--primary-color)] transition-all font-medium disabled:opacity-50 flex items-center justify-center space-x-2"
                    >
                      {orderLoading ? (
                        <>
                          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                          <span>{t.orderLoading}</span>
                        </>
                      ) : (
                        <>
                          <FaPaperPlane />
                          <span>{t.send}</span>
                        </>
                      )}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BooksSearchPage;